<template>
    <nav class="bg-gray-800">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="flex items-center justify-between h-16">
                <div class="flex items-center">
                    <div class="flex-shrink-0">
                        <slot name="logo"></slot>
                    </div>
                    <div class="hidden md:block">
                        <div class="ml-10 flex items-baseline">
                            <slot name="site-nav"></slot>
                        </div>
                    </div>
                </div>
                <div class="hidden md:block">
                    <div class="ml-4 flex items-center md:ml-6">
                        <div class="ml-3 relative">
                            <button
                                class="max-w-xs flex items-center text-sm rounded-full text-white focus:outline-none focus:shadow-solid"
                                @click="toggleProfileDropdown"
                            >
                                <slot name="profile-image"></slot>
                            </button>
                        </div>
                    </div>
                </div>
                <div
                    class="profile-dropdown absolute right-0 mt-4"
                    @click="toggleProfileDropdown"
                    v-if="profileDropdown"
                >
                    <slot name="profile-nav"></slot>
                </div>
                <div class="-mr-2 flex md:hidden">
                    <button
                        class="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:bg-gray-700 focus:text-white"
                        @click="toggleMainDropdown"
                    >
                        <svg
                            class="h-6 w-6"
                            stroke="currentColor"
                            fill="none"
                            viewBox="0 0 24 24"
                        >
                            <path
                                class="inline-flex"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M4 6h16M4 12h16M4 18h16"
                            />
                            <path
                                class="hidden"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M6 18L18 6M6 6l12 12"
                            />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
        <div class="md:hidden" :class="showMainDropdown">
            <slot name="main-dropdown"></slot>
        </div>
    </nav>
</template>
<script>
export default {
    methods: {
        toggleMainDropdown() {
            var timePointer;
            var self = this;
            this.mainDropdown = !this.mainDropdown;
            if (this.mainDropdown) {
                timePointer = setTimeout(function() {
                    self.mainDropdown = false;
                    timePointer = null;
                }, 5000);
            } else {
                clearTimeout(timePointer);
            }
        },
        toggleProfileDropdown() {
            var timePointer;
            var self = this;
            this.profileDropdown = !this.profileDropdown;
            if (this.profileDropdown) {
                timePointer = setTimeout(function() {
                    self.profileDropdown = false;
                    timePointer = null;
                }, 5000);
            } else {
                clearTimeout(timePointer);
            }
        }
    },
    computed: {
        showMainDropdown() {
            return this.mainDropdown ? "block" : "hidden";
        },
        showProfileDropdown() {
            return this.profileDropdown ? "block" : "hidden";
        }
    },
    data() {
        return {
            mainDropdown: false,
            profileDropdown: false
        };
    }
};
</script>